<li class="padding-bottom-0 hide" role="menuitem">
  <span disabled class="button square hollow position-relative flex-dir-column button--icon-on-top">
    <svg class="icon icon--search icon--primary icon--material" viewBox="0 0 24 24">
      <use xlink:href="#icon-search" href="#icon-search"></use>
    </svg>
    <div class="icon-text" >search</div>
  </span>
</li>